import React, { useMemo } from 'react';
import { Checkbox, Form, Gutter } from '@axiom/ui';
import type { Account, AccountEmailsOptedOutType } from '@axiom/validation';

import { AccountsApi } from '../../api/accounts-api';
import { AccountStore } from '../../stores/account-store';

import type { ManageAccountEmailsForm } from './manage-account-emails-form-schema';
import { ManageAccountEmailsFormSchema } from './manage-account-emails-form-schema';

export const ManageAccountEmails = ({ account }: { account: Account }) => {
  const initValues = useMemo(() => {
    const data: Record<AccountEmailsOptedOutType, boolean> = {
      BenchUpdates: true,
      AvailabilityUpdates: true,
    };

    (account.emailsOptedOut || []).forEach(item => {
      data[item] = false;
    });

    return data;
  }, [account.emailsOptedOut]);

  const handleOnChange = async (formData: Partial<ManageAccountEmailsForm>) => {
    const payload = {
      emailsOptedOut: Object.entries({
        ...initValues,
        ...formData,
      }).reduce<AccountEmailsOptedOutType[]>((acc, [key, value]) => {
        if (!value) {
          const data = key as AccountEmailsOptedOutType;
          acc.push(data);
        }
        return acc;
      }, []),
    };

    await AccountsApi.updateAccount(account.id, payload);
    await AccountsApi.invalidateAccount(account.id);
    await AccountStore.load(account.id);
  };

  return (
    <Form
      name="MANAGE_ACCOUNT_EMAILS"
      schema={ManageAccountEmailsFormSchema}
      initialValues={initValues}
      submitOnChange
      onSubmit={formData => {
        void handleOnChange(formData);
      }}
    >
      {() => {
        return (
          <>
            <Checkbox
              name="BenchUpdates"
              label="Bench Updates"
              displayValue="Clients on this account are alerted when there are additions or changes to talent on their bench."
            />
            <Gutter bottom="24px" />
            <Checkbox
              name="AvailabilityUpdates"
              label="Availability Updates"
              displayValue="Clients on this account are alerted when there are availability changes to talent on their bench."
            />
          </>
        );
      }}
    </Form>
  );
};
